import Api from '../Base'

class PatchMoveShelf extends Api {
  requestUrl = `/api/SpaceInstance/${this.getParams().spaceInstanceId}/UpdateShelvesOrder`

  method = 'PATCH'
}

export default PatchMoveShelf
